var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSolidChevronDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 6"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M.759.12h8.482a.76.76 0 0 1 .537 1.295L5.537 5.656a.76.76 0 0 1-1.074 0l-4.24-4.24A.76.76 0 0 1 .758.118"
})));
export { SvgSolidChevronDown as ReactComponent };
export default __webpack_public_path__ + "1014450af8b9258b421f0237340bf211.svg";